import { LANGUAGE } from '../../../config/storyblok/languages'
import { graphql, useStaticQuery } from 'gatsby'
import { useCurrentLanguageKey } from '../context/i18n'

export const useContactFormReasonOptions = () => {
  const query = graphql`
    {
      allStoryblokDatasourceEntry(filter: { data_source: { eq: "contact-form-reason-options" } }) {
        nodes {
          value
          name
          data_source_dimension
          dimension_value
          data_source
        }
      }
    }
  `

  const currentLanguageKey = useCurrentLanguageKey()
  const res = useStaticQuery(query)
  const { nodes } = res.allStoryblokDatasourceEntry

  return nodes
    .filter(node => {      
      return currentLanguageKey === LANGUAGE.EN ? (node.data_source_dimension === null || node.data_source_dimension === LANGUAGE.EN) : node.data_source_dimension === currentLanguageKey;
    })
    .map(node => {
      return {
        name: node.dimension_value || node.value,
        value: node.name,
      }
    })
}
